export default "__VITE_ASSET__03970e5b__"